export default "__VITE_ASSET__DOlj4FX0__"